import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_2024_6752)",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.214 0a1.929 1.929 0 0 0-1.928 1.929v11.467L.033 17.154a.643.643 0 0 0 .766.827l5.066-1.267H16.07A1.93 1.93 0 0 0 18 14.786V1.929A1.928 1.928 0 0 0 16.071 0H3.214Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.918 4.592a1.295 1.295 0 0 0-1.547 1.27.804.804 0 1 1-1.607 0 2.902 2.902 0 1 1 3.705 2.788v.709a.804.804 0 0 1-1.607 0V7.96c0-.444.36-.804.803-.804a1.295 1.295 0 0 0 .253-2.564Zm-.253 9.067a1.153 1.153 0 0 1 .003-2.306h.003a1.153 1.153 0 0 1-.003 2.306h-.003Z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }